import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuItemCounter } from '../../../workstock/MenuItemCounter';

@Component({
    selector: 'sera-tab-holder',
    templateUrl: './sera-tab-holder.component.html',
    styleUrls: ['./sera-tab-holder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraTabHolderComponent implements OnChanges {
    @Input()
    items: MenuItem[] | MenuItemCounter[] = [];

    @Input()
    isTabHolderButtons: boolean = false;

    @Input()
    isToHaveCloseIcon: boolean = false;

    @Input()
    activeItem: MenuItem | MenuItemCounter | undefined;

    @Input()
    styleClass: string = '';

    @Input()
    tabStyleClass: string = '';

    @Input()
    readOnly: boolean = false;

    @Output()
    changeOfActiveItem: EventEmitter<MenuItem> = new EventEmitter();

    @Output()
    closeIconEvent: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

    constructor(private readonly router: Router, private readonly route: ActivatedRoute, private readonly cdr: ChangeDetectorRef) {}

    ngOnChanges(): void {
        if (!this.activeItem && this.items?.length) {
            const url = this.router.url;
            const matchedItem = this.items.find(item => item.routerLink?.some((segment: string) => url.includes(segment)));
            this.activeItem = matchedItem || this.items[0];
        }
    }

    onTabChange(value: string): void {
        if (this.readOnly) return;
        const item = this.items.find(i => i.label === value);
        if (item) {
            this.activeItem = item;
            this.cdr.markForCheck();
            if (item.routerLink) {
                this.router.navigate(item.routerLink, { relativeTo: this.route });
            }
            this.changeOfActiveItem.emit(item);
        }
    }
}
